import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "footer" }

import DirectoryListView from './list-view/DirectoryListView.vue'
import SimpleFormModal from './SimpleFormModal.vue'
import { computed, ref, toRefs, watch } from 'vue'
import { DirectoryItem } from './types'
import BreadcrumbFiles from './BreadcrumbFiles.vue'
import { useFileManagerConnected } from './useFileManagerConnected'

type Props = {
  title: string
  path: DirectoryItem<'directory'>[]
  submitButtonText?: string
  multiSelect?: boolean
  open?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DirectoryItemSelectionModal',
  props: {
    title: {},
    path: {},
    submitButtonText: { default: 'Submit' },
    multiSelect: { type: Boolean, default: false },
    open: { type: Boolean, default: false }
  },
  emits: ["submit", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const { title, submitButtonText, path } = toRefs(props)
const fileManager = useFileManagerConnected(path.value[path.value.length - 1]?.id)

const selectedItems = ref<DirectoryItem[]>([])

const emit = __emit

const isOpen = ref(props.open)

const submitDisabled = computed(() => {
  return false
})

watch(
  path,
  async (newPath) => {
    if (newPath.length) {
      const current = newPath[newPath.length - 1]
      await fileManager.addPath(newPath)
      await fileManager.openItem(current)
      await fileManager.refresh()
    }
  },
  { immediate: true }
)

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue
  },
  { immediate: true }
)

const handleSelect = (items: DirectoryItem[]) => {
  selectedItems.value = items
}

const handleSubmit = () => {
  if (!submitDisabled.value) {
    isOpen.value = false
    if (selectedItems.value.length === 0) {
      const node = fileManager.currentDirectory.value
      if (node) {
        emit('submit', [node])
      }
    } else {
      emit('submit', selectedItems.value)
    }
  }
  selectedItems.value = []
}

const handleClose = () => {
  selectedItems.value = []
  isOpen.value = false
  emit('close')
}

async function onBreadcrumbClick(option: DirectoryItem) {
  if (!option.id) {
    console.warn('Breadcrumb has no id—skipping navigation', option)
    return
  }
  await fileManager.openItem(option.id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleFormModal, {
    class: "custom-modal",
    title: _unref(title),
    "submit-button-text": _unref(submitButtonText),
    open: isOpen.value,
    "disable-submit": submitDisabled.value,
    onClose: handleClose,
    onSubmit: handleSubmit
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(DirectoryListView, {
          directoryItems: _unref(fileManager).displayedItems.value,
          actions: [],
          "disabled-types": ['file', 'link'],
          "multi-select-enabled": _ctx.multiSelect,
          onSelect: handleSelect,
          onDoubleClick: _unref(fileManager).openItem,
          onLoadMoreItems: _unref(fileManager).loadMoreItems
        }, null, 8, ["directoryItems", "multi-select-enabled", "onDoubleClick", "onLoadMoreItems"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BreadcrumbFiles, {
          breadcrumbs: _unref(fileManager).breadcrumbs.value,
          onOnClicked: onBreadcrumbClick
        }, null, 8, ["breadcrumbs"])
      ])
    ]),
    _: 1
  }, 8, ["title", "submit-button-text", "open", "disable-submit"]))
}
}

})